/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorYoutube from 'base/components/labrador/Youtube';

export const DynamicLabradorYoutube: typeof LabradorYoutube = (props) => {
    return <ErrorBoundary><LabradorYoutube {...props} /></ErrorBoundary>;
}
export type DynamicLabradorYoutubeProps = PropsFromComponent<typeof LabradorYoutube>;
